export default "__VITE_ASSET__BkNZedtZ__"